module.exports = __webpack_public_path__ + "img/filter-by-scope-drop-down.df3328d6.png";